import { NODE_ENV } from 'constants/environment';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';

export const useIsPendoEnabled = (): {
  isPendoEnabled: boolean;
} => {
  const { [FeatureFlag.Pendo]: isPendoFlagEnabled } = useFeatureFlags();
  return {
    isPendoEnabled: NODE_ENV !== 'development' && pendo && !!isPendoFlagEnabled,
  };
};
